import { ReactNode } from "react";

import Support from "@/__core/helpers/components/Support";
import { Box, Divider, Paper } from "@mui/material";
const storeStaffImg = '/media/store_staff.webp';



export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <>
       <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${storeStaffImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          width: '100%',
          height: '100%',
          bgcolor: 'rgba(0,0,0,0.5)',
          zIndex: 1,
        },
      }}
    >
      <Paper
        elevation={8}
        sx={{
          position: 'relative',
          zIndex: 2,
          p: 4,
          borderRadius: 1,
          minWidth: 400,
          maxWidth: 400,
          mx: 2,
        }}
      >
        <Box display="flex" justifyContent="center" mb={4}>
          <img src="/media/logo_new-1024x198.png" alt="XBox" style={{ height: 30 }} />
        </Box>
        {children}
      </Paper>
      <Support />
    </Box>
    </>
  );
}
// This component serves as a simple header for authentication pages.